import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Card } from '@/components/ui/Card';
import { ListItem } from '@/components/ui/ListItem';
import { Button } from '@/components/ui/Button';
import { useCompany, useColleaguesNearby } from '@/api/queries/employer';
import { Spinner } from '@/components/ui/Spinner';

export function BusinessDetailPage(): JSX.Element {
  const { t } = useTranslation();
  const company = useCompany();
  const colleagues = useColleaguesNearby();

  // RequireEmployerAdmin gates the route; reaching here implies employer_admin.
  // If company is somehow null (e.g. backend race) we still show a graceful state.

  const colleaguesSubtitle = (() => {
    if (colleagues.isLoading) return t('common.loading');
    const list = colleagues.data;
    if (!list) return t('business.colleagues_nearby_off');
    if (list.length === 0) return t('business.colleagues_nearby_empty');
    return t('business.colleagues_nearby_count', { count: list.length });
  })();

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('business.active_title')} bell />
        {company.isLoading && <Spinner />}
        {!company.isLoading && !company.data && (
          <Card variant="light" padding="md">
            <div style={{ fontWeight: 600 }}>{t('business.no_company_title')}</div>
            <div style={{ color: 'var(--color-text-on-light-muted)', marginTop: 6 }}>
              {t('business.no_company_body')}
            </div>
          </Card>
        )}
        {company.data && (
          <Card variant="light" padding="md">
            <div style={{ fontWeight: 700, fontSize: 18 }}>{company.data.legal_name}</div>
            <ListItem title={t('business.evacuation_class')} trailing={t('booking.class.business')} />
            <ListItem title={t('business.family_safety_mode')} trailing={t('business.family_safety_paid')} />
            <ListItem title={t('business.colleagues_nearby')} subtitle={colleaguesSubtitle} />
            <Button block style={{ marginTop: 12 }}>{t('business.contact')}</Button>
          </Card>
        )}
      </PageContainer>
    </AppShell>
  );
}
